import React from 'react'; 
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import HomePage from './components/HomePage';
import StorePage from './components/StorePage';
import ProductPage from './components/ProductPage';
import DashboardPage from './components/DashboardPage';
import Login from './pages/login';
import CityPage from './pages/CityPage';
import Register from './pages/Register';
import SearchResults from './components/SearchResults';
import AddProductPage from './pages/AddProductPage';
import CreateStorePage from './components/CreateStorePage';
import LaunchPage from './components/LaunchPage';

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <Routes>
          {/* Root path shows the launch page instead of homepage */}
          <Route path="/" element={<LaunchPage />} />
          
          {/* Keep the original homepage accessible at /home */}
          <Route path="/home" element={<HomePage />} />
          
          <Route path="/launch" element={<LaunchPage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/city/:cityName" element={<CityPage />} />
          <Route path="/:city/:storeName" element={<StorePage />} />
          <Route path="/:city/:storeName/product/:productId" element={<ProductPage />} />
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/search" element={<SearchResults />} />
          <Route path="/dashboard/add" element={<AddProductPage />} />
          <Route path="/createstore" element={<CreateStorePage />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;